module.exports = __webpack_public_path__ + "img/icon-question.c55d2f0a.svg";